import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

// TODO: Use OpenAPI when available
type EmailUnsubscribeRequestBody = {
  token: string;
};

export const emailUnsubscribe = async ({ body }: BodyRequest<EmailUnsubscribeRequestBody>) =>
  nodeApiClient.post<unknown, ApiClientResponse<unknown>>(nodeApiRoutes.unsubscribe.email, body);
